import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "slide-item bg-white rounded-borders q-pa-md" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "button-wrap row no-wrap justify-center" }
const _hoisted_4 = { class: "fullscreen-overlay bg-black flex flex-center" }
const _hoisted_5 = { class: "zoom-controls absolute-bottom-right q-ma-lg" }
const _hoisted_6 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slide_item_button = _resolveComponent("slide-item-button")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_touch_pan = _resolveDirective("touch-pan")!
  const _directive_touch_pinch = _resolveDirective("touch-pinch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      style: _normalizeStyle({ 'background-image': `url('${_ctx.slide.image}')` }),
      class: "image cursor-pointer",
      ref: "sliderImage",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openFullscreen && _ctx.openFullscreen(...args)))
    }, null, 4),
    _createElementVNode("p", {
      innerHTML: _ctx.slide.description,
      class: "q-mt-sm text-body2 q-mb-none"
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_slide_item_button, {
        button: _ctx.slide.button,
        onClickButtonWithPayload: _cache[1] || (_cache[1] = 
					(payload) => _ctx.$emit('click-button-with-payload', payload)
				)
      }, null, 8, ["button"])
    ]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isFullscreen,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.isFullscreen) = $event)),
      maximized: "",
      "transition-show": "fade",
      "transition-hide": "fade",
      onHide: _ctx.resetZoom
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_q_btn, {
            icon: "close",
            color: "white",
            class: "close-btn absolute-top-right q-ma-md",
            onClick: _ctx.closeFullscreen,
            round: "",
            dense: "",
            flat: "",
            size: "lg"
          }, null, 8, ["onClick"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_q_btn, {
              icon: "add",
              color: "white",
              onClick: _ctx.zoomIn,
              round: "",
              dense: "",
              flat: ""
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              icon: "remove",
              color: "white",
              onClick: _ctx.zoomOut,
              round: "",
              dense: "",
              flat: ""
            }, null, 8, ["onClick"]),
            _createVNode(_component_q_btn, {
              icon: "refresh",
              color: "white",
              onClick: _ctx.resetZoom,
              round: "",
              dense: "",
              flat: ""
            }, null, 8, ["onClick"])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "zoom-container",
            onWheel: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleWheel && _ctx.handleWheel(...args)))
          }, [
            _createElementVNode("img", {
              ref: "fullscreenImage",
              src: _ctx.slide.image,
              draggable: "false",
              onDragstart: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
              onDblclick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleZoom && _ctx.toggleZoom(...args))),
              alt: _ctx.slide.description,
              class: "fullscreen-image",
              style: _normalizeStyle({
							transform: `translate(${_ctx.panX}px, ${_ctx.panY}px) scale(${_ctx.zoomLevel})`,
							transition: _ctx.isZooming ? 'none' : 'transform 0.2s ease',
							cursor: _ctx.isDragging ? 'grabbing' : _ctx.zoomLevel > 1 ? 'grab' : 'zoom-in'
						})
            }, null, 44, _hoisted_6)
          ], 32)), [
            [
              _directive_touch_pan,
              _ctx.handlePan,
              void 0,
              { mouse: true }
            ],
            [_directive_touch_pan, _ctx.handlePan],
            [_directive_touch_pinch, _ctx.handlePinch]
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onHide"])
  ]))
}